import { useTrans } from "~/hooks/useTrans";
import MyAlert from "~/mui/MyAlert";
import { myUseState } from "~/hooks/myUseState";
import ExternalLink from "~/components/ExternalLink";
import { PRICE_LIST_LINK } from "~/const";
import WhatAbout from "~/components/WhatAbout";

interface IState {
	showInfo: boolean;
}

export default function TariffWhatAbout() {
	const { trans } = useTrans();
	const { state, updateState } = myUseState<IState>({
		showInfo: false,
	});

	function onClick() {
		updateState({
			showInfo: true,
		});
	}

	return <div className="tariffWhatAbout">
		<WhatAbout onClick={onClick} />
		{ state.showInfo && <MyAlert onClose={() => updateState({ showInfo: false })} title={trans("betterTariffRequestModal.specification")} cancelCaption={trans("close")}>
			<p>
				{ trans("tariffWhatAbout.descLine1") }<br />
				{ trans("tariffWhatAbout.descLine2") }<br />
				{ trans("tariffWhatAbout.descLine3") }&nbsp;
				<ExternalLink to={PRICE_LIST_LINK}>
					{ trans("tariffWhatAbout.priceList") }
				</ExternalLink>.
			</p>
		</MyAlert> }
	</div>;
}
